module.exports = __webpack_public_path__ + "static/img/9.c0704c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/9.png
// module id = qOWE
// module chunks = 0